
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AppCoachTrainingsCategoriesListFormRemove} from "@/models/app/coach/trainings/categories/list/form/remove";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElButton,
} from "element-plus";
import {Delete} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "trainingCategory",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElButton,
    Delete,
  },
})
export default class AppCoachTrainingsCategoriesListFormRemoveIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  trainingCategory: AppCoachTrainingsCategoriesListFormRemove = new AppCoachTrainingsCategoriesListFormRemove();

  formData: AppCoachTrainingsCategoriesListFormRemove = new AppCoachTrainingsCategoriesListFormRemove();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/administration/training-category/remove",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getTrainingCategories');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  setFormData(): void {
    this.formData = this.trainingCategory;
  }

  resetFormData(): void {
    this.formData = new AppCoachTrainingsCategoriesListFormRemove();
  }

  updated(): void {
    this.setFormData();
  }
}
